<script>
export default {
  name: 'Pagination'
}
</script>

<script setup>
import {ref, computed} from 'vue';

const props = defineProps({
  isShowFirstAndLastBtn: {
    type: Boolean,
    default: false
  },
  isShowPaginationInfo: {
    type: Boolean,
    default: true
  },
  totalNum: {
    type: Number,
    default: 0
  },
  currentPage: {
    type: Number,
    required: true
  },
  totalPage: {
    type: Number,
    required: true
  },
  pageSize: {
    type: Number,
    required: true
  },
  hasNext: {
    type: Boolean,
    required: false,
    default: false
  },
  pageSizeSelectList: {
    type: Array,
    required: true
  },
  screenId: {
    type: String,
    required: false,
    default: ''
  },
  isAllQuantitiesZero: {
    type: Boolean,
    required: false,
    default: false
  }
});

const emit = defineEmits(['changePageNum', 'changePageSize', 'clickHistoryPdf', 'clickFavoriteAddToCart']);

// 表示件数
const displayIndex = computed({
  get() {
    if (props.totalNum < props.pageSize * props.currentPage) {
      return ( (props.pageSize * (props.currentPage - 1)) + 1) + '-' + props.totalNum;
    }else {
      return ( (props.pageSize * (props.currentPage - 1)) + 1) + '-' + (props.pageSize * props.currentPage);
    }
  }
});

// 表示ページ番号リスト
const displayPageNumbers = ref([])

const calcDisplayPageNumbers = computed({
  get() {
    // 表示ページ数5ページ以内
    if (props.totalPage <= 5) {
      return [...Array(props.totalPage)].map((_, i) => i+1);
    }
    // 表示中のページが1, 2ページ目
    if (props.currentPage < 3) {
      return [1, 2, 3, 4, 5];
    }

    const pagesArray = [...Array(10)].map((_, i) => (props.currentPage-4)+i);
    if (pagesArray[4] == props.totalPage) {
      return pagesArray.slice(0, 5)
    }else if (pagesArray[5] == props.totalPage) {
      return pagesArray.slice(1, 6)
    }else {
      return pagesArray.slice(2, 7)
    }
  }
})

// 表示件数セレクトボックス選択値
const pageSize = computed({
  get: () => props.pageSize,
  set: (value) => emit('changePageSize', value)
});

// 確定したページ番号を親へ通知する
const emitChangePageNum = (page) => {
  if (!Number.isFinite(page) || page < 1 || page > props.totalPage || page === props.currentPage) {
    return;
  }
  emit('changePageNum', page);
};
</script>

<template>
<nav class="com_pagenation1">
  <p class="text1 text-center" v-if="isShowPaginationInfo">検索結果{{ props.totalNum }}件のうち {{ displayIndex }}件</p>
  <ul class="pagination justify-content-center">
    <li class="page-item" @click="emitChangePageNum(1)"
        v-if="props.isShowFirstAndLastBtn && (props.currentPage != 1)">
      <a class="prev2">First</a>
    </li>
    <li class="page-item" @click="emitChangePageNum(props.currentPage - 1)" v-if="props.currentPage != 1">
      <a class="prev">Previous</a>
    </li>
    <li class="page-item" @click="emitChangePageNum(pageNumber)" v-for="pageNumber in calcDisplayPageNumbers"
        v-bind:class="pageNumber == props.currentPage ? 'active' : ''">
      <a>{{ pageNumber }}</a>
    </li>
    <li class="page-item" @click="emitChangePageNum(props.currentPage + 1)" v-if="props.currentPage != props.totalPage">
      <a class="next">Next</a>
    </li>
    <li class="page-item" @click="emitChangePageNum(props.totalPage)"
          v-if="props.isShowFirstAndLastBtn && (props.currentPage != props.totalPage)">
      <a class="next2">Last</a>
    </li>
  </ul>
  <select class="form-select com_form1" v-model="pageSize">
    <option v-for="pageSize in pageSizeSelectList" :value="pageSize"
            v-bind:selected="pageSize == props.pageSize ? true : false">{{ pageSize }}
    </option>
  </select>
  <template v-if="props.screenId === 'OrderHistory'">
    <button type="button" @click="emit('clickHistoryPdf')" class="btn com_btn11">発注履歴帳票<img src="/front/assets/common/img/icon_paper1.png" alt="" class="icon_paper1"></button>
  </template>
  <template v-else-if="props.screenId === 'OrderFavoriteDetail'">
    <button type="button" @click="emit('clickFavoriteAddToCart')" class="btn com_btn11" :disabled="props.isAllQuantitiesZero">すべてカートへ</button>
  </template>
</nav>
</template>

<style scoped>
.page-item > a {
  cursor: pointer;
}
.page-item.active {
  pointer-events: none;
  > a {
    cursor: default;
  }
}
</style>
